import React, { useState } from "react";

const BlogComments = ({ comments, commentsEnabled }) => {
  const [commentInput, setCommentInput] = useState("");
  const [replyInputs, setReplyInputs] = useState({});
  const [userDetails, setUserDetails] = useState(null); // Example for user auth handling

  const handleCommentSubmit = (e) => {
    e.preventDefault();
    setCommentInput("");
  };

  const handleReplySubmit = (commentId, reply) => {
    setReplyInputs({ ...replyInputs, [commentId]: "" });
  };

  const toggleReplyInput = (commentId) => {
    setReplyInputs({
      ...replyInputs,
      [commentId]: replyInputs[commentId] === undefined ? "" : undefined,
    });
  };

  if (!commentsEnabled) {
    return (
        <div className="comments-disabled-card">
          <p>ⓘ Comments are turned off for this blog.</p>
        </div>
      );
  }

  return (
    <div className="comments-section">
      <h2>Comments</h2>

      {/* Render Comments */}
      {comments.length > 0 ? (
        comments.map((comment) => (
          <div key={comment.id} className="comment">
            <div className="comment-header">
              <strong>{comment.userDetails.name}</strong> said:
            </div>
            <p>{comment.content}</p>

            {/* Reply Section */}
            <div className="reply-section">
              <button
                onClick={() => toggleReplyInput(comment.id)}
                className="reply-button"
              >
                Reply
              </button>

              {/* Show reply input if toggled */}
              {replyInputs[comment.id] !== undefined && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleReplySubmit(comment.id, replyInputs[comment.id]);
                  }}
                  className="reply-form"
                >
                  <textarea
                    value={replyInputs[comment.id]}
                    onChange={(e) =>
                      setReplyInputs({
                        ...replyInputs,
                        [comment.id]: e.target.value,
                      })
                    }
                    placeholder="Write a reply..."
                    required
                  />
                  <button type="submit">Post Reply</button>
                </form>
              )}

              {/* Render Replies */}
              {comment.replies &&
                comment.replies.map((reply) => (
                  <div key={reply.id} className="reply">
                    <strong>{reply.userDetails.name}</strong>: {reply.content}
                  </div>
                ))}
            </div>
          </div>
        ))
      ) : (
        <p>No comments yet. Be the first to comment!</p>
      )}

      {/* Add Comment Form */}
      <form onSubmit={handleCommentSubmit} className="comment-form">
        {!userDetails && (
          <>
            <input
              name="name"
              placeholder="Your Name"
              required
              className="input-field"
            />
            <input
              name="phone"
              placeholder="Your Phone"
              required
              className="input-field"
            />
            <input
              name="email"
              placeholder="Your Email"
              required
              className="input-field"
            />
          </>
        )}
        <textarea
          placeholder="Write a comment..."
          value={commentInput}
          onChange={(e) => setCommentInput(e.target.value)}
          required
        />
        <button type="submit">Post Comment</button>
      </form>
    </div>
  );
};

export default BlogComments;
